import { useState } from "react";
import logo from "../../assets/logoCopie.png";
import { Link } from "react-scroll"; // Importer Link depuis react-scroll

const Header = () => {
  const [isExpanded, setIsExpanded] = useState(true); // État initial à true

  const handleMenuClick = () => {
    // Sélectionner l'élément avec la classe .navbar-toggle
    const navButton = document.querySelector(
      ".navbar-toggle",
      ".navbar-collapse"
    );
    const navMenu = document.querySelector(".navbar-collapse");
    const icoMenu = document.querySelector(".fa, .fa-times");
    icoMenu.className = "fa fa-bars";
    navButton.setAttribute("aria-expanded", `${isExpanded}`); // Mettre aria-expanded à false
    navButton.className = "navbar-toggle collapsed";
    navMenu.setAttribute("aria-expanded", `${isExpanded}`); // Mettre aria-expanded à false
    navMenu.className = "navbar-collapse menu-ui-design collapse";
    setIsExpanded(false); // Mettre à jour l'état isExpanded
  };

  return (
    <header className="top-area">
      <div className="header-area">
        <nav className="navbar navbar-default bootsnav navbar-fixed dark no-background">
          <div className="container">
            <div className="navbar-header">
              <button
                type="button"
                aria-label="button-menu"
                className="navbar-toggle"
                data-toggle="collapse"
                data-target="#navbar-menu"
              >
                <i className="fa fa-bars"></i>
              </button>
            </div>
            <a className="navbar-brand" href="/">
              <img src={logo} className="logo_img" alt="logo" />
            </a>
            <div
              className="collapse navbar-collapse menu-ui-design"
              id="navbar-menu"
            >
              <ul
                className="nav navbar-nav navbar-right"
                data-in="fadeInDown"
                data-out="fadeOutUp"
              >
                <li className=" smooth-menu active"></li>
                <li className="smooth-menu">
                  <Link
                    to="welcome-hero"
                    href="#welcome-hero"
                    onClick={handleMenuClick}
                    smooth={true} // Activer le défilement fluide
                    duration={1000}
                    offset={2}
                  >
                    Accueil
                  </Link>
                </li>

                <li className="smooth-menu">
                  <Link
                    to="services"
                    href="#services"
                    onClick={handleMenuClick}
                    smooth={true} // Activer le défilement fluide
                    duration={1000}
                    offset={100}
                  >
                    Expertise
                  </Link>
                </li>
                <li className="smooth-menu">
                  <Link
                    to="projet"
                    href="#projet"
                    onClick={handleMenuClick}
                    smooth={true} // Activer le défilement fluide
                    duration={1000}
                    offset={2}
                  >
                    Réalisation
                  </Link>
                </li>
                <li className="smooth-menu">
                  <Link
                    smooth={true} // Activer le défilement fluide
                    duration={1000}
                    to="about"
                    href="#about"
                    onClick={handleMenuClick}
                    offset={2}
                  >
                    L'agence
                  </Link>
                </li>

                <li className="smooth-menu">
                  <Link
                    smooth={true} // Activer le défilement fluide
                    duration={1000}
                    to="contact"
                    href="#contact"
                    onClick={handleMenuClick}
                    offset={2}
                  >
                    Contact
                  </Link>
                </li>
              </ul>
            </div>
          </div>
        </nav>
      </div>
      <div className="clearfix"></div>
    </header>
  );
};

export default Header;
